/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay} from '@chakra-ui/react'
import ProductView from '../../partials/product-view'
import {useProductViewModal} from '../../hooks/use-product-view-modal'
import {useIntl} from 'react-intl'

/**
 * A Modal that contains Product View
 */
const ProductViewModal = ({product, isOpen, onClose, context, finalFocusRef, ...props}) => {
    const productViewModalData = useProductViewModal(product)
    const {formatMessage} = useIntl()
    return (
        <Modal
            variant="productView"
            size="lg"
            isOpen={isOpen}
            onClose={onClose}
            colorScheme="stokkeCore"
            finalFocusRef={finalFocusRef}
            returnFocusOnClose={
                // restoring the focus prevents the page from scrolling to the top
                finalFocusRef ? true : false
            }
        >
            <ModalOverlay />
            <ModalContent
                containerProps={{'data-testid': 'product-view-modal'}}
                aria-label={formatMessage({
                    id: 'product_tile.assistive_msg.product_view',
                    defaultMessage: 'Product view'
                })}
            >
                <ModalCloseButton />
                <ModalBody>
                    <ProductView
                        showFullLink={true}
                        context={context}
                        imageSize="sm"
                        product={productViewModalData.product}
                        isLoading={productViewModalData.isFetching}
                        onClose={onClose}
                        {...props}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

ProductViewModal.propTypes = {
    finalFocusRef: PropTypes.object,
    isOpen: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    product: PropTypes.object,
    isLoading: PropTypes.bool,
    context: PropTypes.string,
    actionButtons: PropTypes.node,
    onModalClose: PropTypes.func
}

export default ProductViewModal
